module.exports = __webpack_public_path__ + "img/FIAT.1044d99d.svg";